module.exports = __webpack_public_path__ + "img/icon-192x192.c937a646.png";